<template>
  <div>
    <div class="mainbox pr1">
      <div class="logo" @click="$router.push('/')">
        <b>Blockchain</b>
        <p>Venture Capital</p>
      </div>
      <div class="clang">
        <i class="iconfont icon-shixindiqiu"></i>
        <ChangeLang />
      </div>
      <img
        :src=" local != 'en' ?  require('../assets/images/mobile-dl-cn.png') : require('../assets/images/mobile-dl.png')"
        alt
      />
      <div class="txt">
        <p>BVC Pay</p>
        <p>{{lang[local].dl_txt2}}</p>
        <ul class="tt">
          <li>
            <span>•</span>
            {{lang[local].dl_txt3}}
          </li>
          <li>
            <span>•</span>
            {{lang[local].dl_txt4}}
          </li>
          <li>
            <span>•</span>
            {{lang[local].dl_txt5}}
          </li>
        </ul>
      </div>
      <!-- 下载按钮 -->
      <div class="link">
        <!-- iOS -->
        <a @click="togglebtns1" class="btn">
          <!-- <i class="iconfont icon-pingguo-copy"></i>
          <div class="right">
            <p class="p1">Download for</p>
            <p class="p2">iOS</p>
          </div> -->
          <img class="row2img" src="../assets/images/1.png" alt />
        </a>
        <div class="androidbtns" style="left:0" v-show="showbtns1">
          <a class="row1" href="https://testflight.apple.com/join/FMn5gktv" target="_bank">
            <!-- <i class="iconfont icon-xiazai2"></i>
            <span>{{lang[local].direct_download}}</span> -->
            <img class="row2img" src="../assets/images/2.png" alt />
          </a>

          <a
            class="row2"
            href="https://itunes.apple.com/us/app/bvc-pay/id1449227103"
            target="_bank"
          >
            <!-- <i class="iconfont icon-pingguo-copy"></i>
            <p class="p2">APP Store</p> -->
            <img class="row2img" src="../assets/images/3.png" alt />
          </a>
        </div>
        <!-- 安卓 -->
        <a @click="togglebtns" class="btn">
          <!-- <i class="iconfont icon-anzhuo1 anzhuocss"></i>
          <div class="right">
            <p class="p1">Download for</p>
            <p class="p2">Android</p>
          </div> -->
          <img class="row2img" src="../assets/images/4.png" alt />
        </a>
        <div class="androidbtns" v-show="showbtns">
          <a class="row1" href="https://files.bvcadt.com/static/apk/bvcadt_release.apk">
            <!-- <i class="iconfont icon-xiazai2"></i>
            <span>{{lang[local].direct_download}}</span> -->
            <img class="row2img" src="../assets/images/2.png" alt />
          </a>
          <a
            class="row2"
            href="https://play.google.com/store/apps/details?id=com.bvc.adt"
            target="_bank"
            style="pointer-events:none; opacity:0.6"
            disabled
          >
            <img class="row2img" src="../assets/images/5.png" alt />
          </a>
        </div>
      </div>
    </div>
    <div style="background:#f9f9f9">
      <div class="mainbox pr2">
        <h2 class="tit">{{lang[local].dl_txt6}}</h2>
        <p class="subtit">{{lang[local].dl_txt7}}</p>
        <div class="list">
          <div class="box">
            <i class="iconfont icon-icon-"></i>
            <h3>{{lang[local].dl_txt8}}</h3>
            <p>{{lang[local].dl_txt9}}</p>
          </div>
          <div class="box">
            <i class="iconfont icon-anquan1"></i>
            <h3>{{lang[local].dl_txt10}}</h3>
            <p>{{lang[local].dl_txt11}}</p>
          </div>
          <div class="box">
            <i class="iconfont icon-4"></i>
            <h3>{{lang[local].dl_txt12}}</h3>
            <p>{{lang[local].dl_txt13}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pr">
      <div style="padding-top:30px;background:#fff">
        <div class="mainbox pr3">
          <h2 class="tit">{{lang[local].dl_txt14}}</h2>
          <p class="subtit">{{lang[local].dl_txt15}}</p>
          <div class="ctx">
            <div class="phone-small">
              <img
                :src=" local != 'en' ? require('../assets/images/small1-cn.png') : require('../assets/images/small1-en.png')"
              />
            </div>
            <div class="tit">
              <h3>
                <i class="iconfont icon-shuju"></i>
                <span>{{lang[local].dl_txt16}}</span>
              </h3>
            </div>
            <ul class="cl">
              <li>
                <span>•</span>
                {{lang[local].dl_txt17}}
              </li>
              <li>
                <span>•</span>
                {{lang[local].dl_txt18}}
              </li>
            </ul>
            <div class="tip">{{lang[local].dl_txt19}}</div>
          </div>
          <div class="pic" :style="local !='en' ? 'background-position-y:507px':'' "></div>
        </div>
      </div>
      <div style="padding-top:30px;background:#f9f9f9">
        <div class="mainbox pr4">
          <div class="ctx">
            <div class="phone-small">
              <img
                :src=" local != 'en' ? require('../assets/images/small2-cn.png') : require('../assets/images/small2-en.png')"
              />
            </div>
            <div class="tit">
              <h3>
                <i class="iconfont icon-jiaoyiguanli"></i>
                <span>{{lang[local].dl_txt20}}</span>
              </h3>
            </div>
            <ul class="cl">
              <li>
                <span>•</span>
                {{lang[local].dl_txt21}}
              </li>
              <li>
                <span>•</span>
                {{lang[local].dl_txt22}}
              </li>
              <li>
                <span>•</span>
                {{lang[local].dl_txt23}}
              </li>
            </ul>
          </div>
          <div class="pic" :style="local !='en' ? 'background-position-y:507px':'' "></div>
        </div>
      </div>
      <div style="padding-top:30px;background:#fff">
        <div class="mainbox pr5">
          <div class="ctx">
            <div class="phone-small">
              <img
                :src=" local != 'en' ? require('../assets/images/small3-cn.png') : require('../assets/images/small3-en.png')"
              />
            </div>
            <div class="tit">
              <h3>
                <i class="iconfont icon-tuandui"></i>
                <span>{{lang[local].dl_txt24}}</span>
              </h3>
            </div>
            <ul class="cl">
              <li>
                <span>•</span>
                {{lang[local].dl_txt25}}
              </li>
              <li>
                <span>•</span>
                {{lang[local].dl_txt26}}
              </li>
              <li>
                <span>•</span>
                {{lang[local].dl_txt27}}
              </li>
            </ul>
          </div>
          <div class="pic" :style="local !='en' ? 'background-position-y:507px':'' "></div>
        </div>
      </div>
    </div>
    <div class="foot">
      <p>Copyright © 2018~2020 Blockchain Venture Capital | All Rights Reserved</p>
    </div>
  </div>
</template>
<script>
import { Button } from "iview";
import { mapState } from "vuex";
import ChangeLang from "../components/changeLang";
export default {
  components: {
    Button,
    ChangeLang
  },
  data() {
    return {
      isSafari:
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent) &&
        !/HUAWEICOL/.test(navigator.userAgent),
      showbtns: false,
      showbtns1: false
    };
  },
  computed: mapState(["lang", "local", "skin"]),
  mounted() {},
  methods: {
    togglebtns() {
      this.showbtns = !this.showbtns;
    },
    togglebtns1() {
      this.showbtns1 = !this.showbtns1;
    }
  }
};
</script>

<style lang="less" scoped>
.mainbox {
  position: relative;
  .ctx {
    float: left;
    width: 70%;
    position: relative;
    top: 100px;
    .tit {
      color: #e95b57;
      margin-bottom: 30px;
      i {
        font-size: 40px;
        background: #e95b57;
        color: #fff;
        border-radius: 10px;
        padding: 4px 5px;
        font-weight: normal;
        vertical-align: middle;
      }
      h3 span {
        font-size: 22px;
        vertical-align: middle;
        display: inline-block;
        width: 50%;
        padding: 5px 30px;
        border-radius: 10px;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
        position: relative;
        &::after {
          content: "";
          width: 0;
          height: 0;
          border-width: 10px 15px 10px 15px;
          border-style: solid;
          border-color: transparent #fff transparent transparent;
          position: absolute;
          left: -22px;
          top: 10px;
          box-shadow: 0 0 0 rgba(0, 0, 0, 0.15);
          z-index: 99;
        }
      }
    }
    ul.cl {
      li {
        font-size: 16px;
        line-height: 30px;
        list-style: none;
        span {
          font-size: 40px;
          color: #e95b57;
          vertical-align: middle;
        }
      }
    }
    .tip {
      margin-top: 80px;
      font-size: 16px;
      line-height: 30px;
    }
  }
  .pic {
    float: right;
    margin-bottom: 30px;
    background: url("../assets/images/phone.png");
    width: 270px;
    height: 510px;
  }
  &.pr1 {
    color: #fff;
    min-height: 600px;
    .logo {
      background: #fff url("../assets/images/logo.png") center 10px no-repeat;
      width: 112px;
      height: 120px;
      border-radius: 0 0 5px 5px;
      text-align: center;
      padding-top: 70px;
      color: #912121;
      cursor: pointer;
      b {
        font-size: 16px;
      }
    }
    .txt {
      p:nth-child(1) {
        font-size: 50px;
        margin-top: 50px;
      }
      p:nth-child(2) {
        font-size: 25px;
        width: 58%;
        margin-bottom: 30px;
      }
      ul {
        overflow: hidden;
        font-size: 16px;
        li {
          float: left;
          margin-right: 20px;
          list-style: none;
          span {
            font-size: 26px;
            vertical-align: middle;
          }
        }
      }
    }
    img {
      position: absolute;
      top: 0;
      right: -50px;
    }
    .link {
      margin-top: 6%;
      position: relative;
      .btn {
        margin-right: 5px;
        color: #fff;
        min-width: 150px;
        width: 168px;
        height: 52px;
        background: rgba(244, 44, 85, 1);
        box-shadow: 0px 7px 13px 0px rgba(4, 0, 0, 0.1);
        border-radius: 5px;
        display: inline-block;
        font-size: 15px;
        text-align: center;
        font-weight: 500;
        overflow: hidden;
        .row2img {
             text-align: center;
             display: inline-block;
            position: relative;
            width: 133px;
            height: 29px;
            top: 9px;
            right:-10px;
          }
        i {
          font-size: 34px;
          margin-right: 32px;
          display: inline-block;
          line-height: 52px;
          vertical-align: top;
         
        }
        .right {
          display: inline-block;
          .p1 {
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-top: 5px;
          }
          .p2 {
            font-size: 18px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-top: -1px;
          }
        }
        &.cur,
        &:hover {
          background: #ff2c2c;
        }
        &.no {
          cursor: not-allowed !important;
          background: #d1c5c7;
        }
      }
      .androidbtns {
        width: 168px;
        height: 93px;
        background: rgba(244, 44, 85, 1);
        box-shadow: 0px 7px 13px 0px rgba(4, 0, 0, 0.1);
        border-radius: 5px;
        //padding: 0 11px;
        position: absolute;
        left: 173px;
        .row1 {
          display: block;
          height: 46px;
          line-height: 46px;
          text-align: center;
          border-bottom: 1px solid rgba(251, 103, 134, 1);
          font-size: 14px;
          font-weight: 400;

          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          i {
            color: #fff;
            font-size: 30px;
            font-weight: 500;
       
            display: inline-block;
            vertical-align: middle;
          }
          span{
            display: inline-block;
           
          }
          .row2img {
           text-align: center;
             display: inline-block;
            position: relative;
            width: 135px;
            height: 32px;
            top: 9px;
            right: -10px;
          }
        }
        .row2 {
          display: inline-block;
          height: 46px;
          line-height: 46px;
          text-align: center;
          cursor: pointer;
          width: 100%;
          margin: 0 auto;
          //width: 140px;
          .p2 {
            float: right;
            font-size: 18px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-top: -1px;
       
          }
          .row2img {
            //float: right;
           text-align: center;
             display: inline-block;
            position: relative;
            width: 126px;
            height: 29px;
            top: 9px;
            right: -5px;
          }
          i {
            font-size: 34px;
            margin-right: 18px;
            display: inline-block;
            line-height: 42px;
            vertical-align: top;
            color: #fff;
           
          }
        }
      }
    }
  }
  &.pr2 {
    min-height: 650px;
    padding-top: 30px;
    .list {
      margin-top: 60px;
      overflow: hidden;
      .box {
        float: left;
        border-radius: 4px;
        background: #fff;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
        width: 32%;
        min-height: 200px;
        padding: 50px 45px;
        font-size: 16px;
        position: relative;
        min-height: 280px;
        i {
          font-size: 60px;
          color: #e95b57;
          position: absolute;
          top: 5%;
          right: 15%;
        }
        p {
          line-height: 30px;
        }
        h3 {
          color: #e95b57;
          margin-bottom: 20px;
        }
        &:nth-child(2) {
          margin: 0 2%;
        }
      }
    }
  }
  &.pr3 {
    overflow: hidden;
  }
  &.pr4 {
    overflow: hidden;
    .ctx {
      float: right;
    }
    .pic {
      float: left;
      background-position-x: 273px;
    }
  }
  &.pr5 {
    overflow: hidden;
    .pic {
      background-position-x: 536px;
    }
  }
}
.pr {
  .phone-small {
    display: none;
  }
}
.foot {
  padding: 40px;
  background: #3a2c36;
  text-align: center;
  color: #ddd;
  font-size: 15px;
}
</style>
